window.app.run([
  "toastr",
  function(toastr) {
    var ieVersion = getInternetExplorerVersion();
    if (!window.isDesktop || !ieVersion) {
      return;
    }

    setTimeout(function() {
      warning();
    }, 100);

    function warning() {
      toastr.warning(
        '<div>Internet Explorer detected! For a better experience use a recommended browser such as <a target="_blank" href="https://www.google.com/chrome/browser/desktop/index.html">Google Ghrome</a></div>',
        {
          timeOut: 5000,
          extendedTimeOut: 10000,
          allowHtml: true,
          showDuration: "300",
          hideDuration: "1000",
          tapToDismiss: false,
          closeButton: true,
          closeButtonHtml:
            '<button id="toast-btn" class="toast-close-button"><i class="material-icons pointer-events-none">close</i></button>'
        }
      );
    }

    // Returns the version of Internet Explorer or a -1
    // (indicating the use of another browser).
    function getInternetExplorerVersion() {
      var rv; // Return value assumes failure.
      if (navigator.appName == "Microsoft Internet Explorer") {
        var ua = navigator.userAgent;
        var re = new RegExp("MSIE ([0-9]{1,}[.0-9]{0,})");
        if (re.exec(ua) != null) {
          rv = parseFloat(RegExp.$1);
        }
      }
      return rv;
    }
  }
]);



// WEBPACK FOOTER //
// ./src/services/ieWarning.js